import { RootState } from "redux-store";

export const getNotification = (state: RootState) => state?.notification;
export const isNotificationDialogOpen = (state: RootState) =>
  state?.notification?.isNotificationDialogOpen ?? false;
export const getNotificationsList = (state: RootState) =>
  state?.notification?.list ?? [];
export const getNotificationsCount = (state: RootState) =>
  state?.notification?.notificationsCount ?? 0;
export const getFilterType = (state: RootState) =>
  state?.notification?.filterType ?? "Produzione";
